import type {
  ICatalogBFFMedia,
  ICatalogBFFPromotion,
  ICatalogBFFRatings,
  ICatalogBFFWeighted,
} from "@magnit/unit-catalog/src/unit-catalog.types";

export interface ICatalogBFFDetailedBadge {
  backgroundColor: string;
  textColor: string;
  text: string;
  description?: string;
  descriptionHeader?: string;
  endDate?: string;
  backgroundGradient?: string;
  backgroundIcon?: string;
}

export enum CatalogBFFCharacteristicType {
  COLOR = "COLOR",
  IMAGE = "IMAGE",
  TEXT = "TEXT",
}

interface ICatalogBFFCValue {
  id: string;
  photo?: ICatalogBFFMedia;
  title: string;
  value: string;
}

interface ICatalogBFFCharacteristic {
  id: string;
  title: string;
  type: CatalogBFFCharacteristicType;
  values: ICatalogBFFCValue[];
}

interface ICatalogBFFParameter {
  name: string;
  value: string;
}

export enum CatalogBFFDetailType {
  nutritionFactsType = "nutritionFactsType",
  stringType = "stringType",
  tableType = "tableType",
}

export interface ICatalogBFFDetail {
  name: string;
  parameters?: ICatalogBFFParameter[];
  type: CatalogBFFDetailType;
  value?: string;
}

interface ICatalogBFFSKUCValue {
  characteristicId: string;
  id: string;
}

export interface ICatalogBFFSKU {
  characteristicValues?: ICatalogBFFSKUCValue[];
  gallery: ICatalogBFFMedia[];
  id: string;
  price: number;
  promotion: ICatalogBFFPromotion;
  quantity: number;
  skuGroupId: string;
}

export interface ICatalogBFFDetailedGood {
  badges?: ICatalogBFFDetailedBadge[];
  categories?: number[];
  characteristics?: ICatalogBFFCharacteristic[];
  details?: ICatalogBFFDetail[];
  gallery: ICatalogBFFMedia[];
  id: string;
  isForAdults: boolean;
  isInFavorites?: boolean;
  isLowStock?: boolean;
  name: string;
  orders?: number;
  price: number;
  profit?: number;
  promotion: ICatalogBFFPromotion;
  quantity: number;
  ratings?: ICatalogBFFRatings;
  seoCode?: string;
  skuList?: ICatalogBFFSKU[];
  storeCode: string;
  weighted: ICatalogBFFWeighted;
}
